/**
 * @fileoverview POST handler for the "/apps/:app_group_id/charts/sessions" endpoint
 */
import fetch from "@lib/fetch";
import { jsonToFormData } from "@lib/reportingMetrics";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsSessionsCacheKeys } from "./constants";
import type { PostAppsAppGroupIdChartsSessionsProps, AppsAppGroupIdChartsSessionsResult } from "./types";

export const postAppsAppGroupIdChartsSessions = reactQueryMutationAdapter(
  appsAppGroupIdChartsSessionsCacheKeys,
  ({
    appGroupId,
    startDate,
    endDate,
    appIds,
  }: PostAppsAppGroupIdChartsSessionsProps): Promise<AppsAppGroupIdChartsSessionsResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/sessions`,
      "POST",
      {},
      {
        body: jsonToFormData({
          app_group_id: appGroupId,
          start_date: startDate,
          end_date: endDate,
          app_ids: appIds,
        }),
      },
      {
        setContentType: false,
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
